import { render, staticRenderFns } from "./sagetext.vue?vue&type=template&id=5681f160&scoped=true"
import script from "./sagetext.vue?vue&type=script&lang=js"
export * from "./sagetext.vue?vue&type=script&lang=js"
import style0 from "./sagetext.vue?vue&type=style&index=0&id=5681f160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5681f160",
  null
  
)

export default component.exports